import { SET_USER } from './const';

const initState: UserInfo = {
  shopeeUid: '',
  isLogin: false,
  firstName: '',
  name: '',
  uid: '',
};
interface Action {
  type: string;
  payload: any;
}

const reducer = (state = initState, { type, payload }: Action) => {
  switch (type) {
    case SET_USER:
      return { ...state, ...payload.data };
  }
  return state;
};

export default reducer;
